import React from 'react';
import PropTypes from 'prop-types';

import MenuVoicebotAudios from '../MenuVoicebotAudios';
import MenuVariaveisVoicebot from '../MenuVariaveisVoicebot';

import { Wrapper } from './styles';

const MenuWrapper = ({ onSelect, itemId }) => {
  return (
    <Wrapper>
      <MenuVoicebotAudios
        onSelect={onSelect}
        id={`menu-voicebot-audios-${itemId}`}
      />
      <MenuVariaveisVoicebot
        onSelect={onSelect}
        id={`menu-voicebot-variables-${itemId}`}
      />
    </Wrapper>
  );
};

MenuWrapper.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default MenuWrapper;
